import { styled } from '@mui/material/styles';

export const ReadOnlyNotice = styled('p')({
  margin: '16px 0 0',
  padding: '12px 14px',
  borderRadius: 10,
  fontSize: '0.8125rem',
  lineHeight: 1.5,
  color: '#5a6478',
  background: 'rgba(13, 78, 254, 0.05)',
  border: '1px solid rgba(13, 78, 254, 0.12)',
});
